var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03839 1.45334C3.03839 2.24565 2.43512 2.88685 1.49169 2.88685C0.585028 2.88685 -0.0182487 2.24565 0.000421423 1.45334C-0.0182487 0.622527 0.585014 0 1.50977 0C2.4351 0 3.02031 0.622527 3.03839 1.45334ZM0.0762715 13.2481V4.0193H2.94445V13.2475H0.0762715V13.2481Z",
    fill: "#007BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2437 6.96402C5.2437 5.81289 5.20577 4.83155 5.16785 4.01998H7.65913L7.79156 5.2843H7.84817C8.22565 4.69911 9.16908 3.81287 10.6977 3.81287C12.5845 3.81287 14 5.05851 14 7.77499V13.2488H11.1318V8.13439C11.1318 6.94476 10.7169 6.13378 9.679 6.13378C8.88611 6.13378 8.41469 6.68105 8.22624 7.20906C8.1504 7.39809 8.11305 7.6618 8.11305 7.92669V13.2488H5.24485V6.96402H5.2437Z",
    fill: "#007BFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.66bf75b941fece4bb158902b2e395294.svg";
export { ForwardRef as ReactComponent };